
type Options = {
  languageCodeOnly?: boolean;
};

function getBrowserLocale({languageCodeOnly = false}: Options) {
  const browserLocales =
    navigator.languages === undefined
      ? [navigator.language]
      : navigator.languages;

  if (!browserLocales)
    return undefined;

  return browserLocales.map(locale => {
    const trimmedLocale = locale.trim();
    return languageCodeOnly ? trimmedLocale.split(/-|_/)[0] : trimmedLocale;
  })[0];
}

export const language = getBrowserLocale({ languageCodeOnly: true });